module.exports = __webpack_public_path__ + "img/logo11.27b88899.png";